<template lang="html">
  <!-- <v-container grid-list-lg>
      <v-layout wrap>
        <v-flex xs12 lg10 xl8 mx-auto>
          <v-layout wrap> -->
  <si-container>
    <v-flex>
      <v-layout
        ma-0
        mt-4
        mb-8
        align-center
        justify-center
      >
        <!-- <v-flex class="text-h">Test cases</v-flex> -->
        <!-- <v-spacer></v-spacer> -->
        <v-btn 
          v-if="!showingTests && !loading" 
          outlined 
          color="primary"
          @click="editTestCase()"
        >
          Add test
        </v-btn>
        <div v-if="Object.keys(testCases || {}).length > 0">
          <v-btn
            v-if="!showingTests"
            color="primary"
            class="ml-3"
            :loading="loading"
            depressed
            @click="runTest"
          >
            Run tests
          </v-btn>
          <v-btn
            v-else
            text
            color="grey"
            @click="testResults = []" 
          >
            Clear results
          </v-btn>
        </div>
      </v-layout>

                
      <v-card
        v-for="(c, id) in cases"
        :key="`case_${id}`"
        class="mt-4"
      >
        <v-card-title>
          <v-icon
            v-if="showingTests"
            :color="c.result ? 'success' : 'error'"
            left
          >
            {{ c.result ? 'check_circle' : 'cancel' }}
          </v-icon>
          <div>
            <div :class="titleClass(c)">
              {{ c.title }} - {{ c.id }}
            </div>
            <div
              class="caption"
              v-html="_formatLineBreaks(c.description)"
            />
          </div>
          <v-spacer />
          <v-layout
            v-if="!showingTests && !loading"
            ma-0
            shrink
          >
            <SiDeleteButton 
              title="Delete test case?" 
              message="Are you sure you want to delete this test case?" 
              @delete="deleteTestCase(c)" 
            />
            <v-btn
              icon
              class="ml-2"
              @click="editTestCase(c)"
            >
              <v-icon>edit</v-icon>
            </v-btn>
            <v-tooltip bottom>
              <template #activator="{ on, attrs}">
                <v-btn
                  v-bind="attrs"
                  icon
                  v-on="on"
                  @click="loadCalculation(id)"
                >
                  <v-icon>launch</v-icon>
                </v-btn>
              </template>
              <span>Load test data into calculation</span>
            </v-tooltip>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-flex class="subtitle-1 ">
            Data
          </v-flex>
          <v-divider />
          <v-treeview 
            ref="data"
            :items="_treeViewObject({ data: c.data })"
            open-on-click
            dense
          >
            <template #label="{ item }">
              <div v-html="item.html" />
            </template>
          </v-treeview>
          <v-treeview
            v-if="c.calculation"
            ref="calculation"
            :items="_treeViewObject({ calculation: c.calculation })"
            open-on-click
            dense
          >
            <template #label="{ item }">
              <div v-html="item.html" />
            </template>
          </v-treeview>
          <v-flex class="subtitle-1 mt-4">
            Tests
          </v-flex>
          <v-divider />
          <v-simple-table v-if="c.results">
            <thead>
              <tr><th>Path</th><th>Target</th><th>Value</th><th>Success</th></tr>
            </thead>
            <tbody>
              <tr
                v-for="(test, i) in c.results"
                :key="`test_${i}`"
              >
                <td>{{ test.path }}</td>
                <td width="10">
                  {{ test.target }}
                </td>
                <td width="10">
                  {{ test.value }}
                </td>
                <td width="10">
                  <v-icon :color="test.result ? 'success' : 'error'">
                    {{ test.result ? 'check_circle' : 'error' }}
                  </v-icon>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-simple-table v-else>
            <tbody>
              <tr
                v-for="(test, i) in c.tests"
                :key="`test_${i}`"
              >
                <td>{{ test.path }}</td>
                <td width="10">
                  {{ test.target }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-divider />
          <!-- </v-flex> -->
        </v-card-text>
      </v-card>
    </v-flex>
    <SiTestCaseBuilder 
      v-model="editDialog" 
      :calculator-id="calculatorId" 
      :test-case="editTestCaseData"
    />
  </si-container>
  <!-- </v-layout>
        </v-flex>
    </v-layout>
    
  </v-container> -->
</template>


<script>
import { mapGetters } from 'vuex'
import helpers from '@/mixins/helpers'
import binder from '@/mixins/binder'
import axios from 'axios'

import { rtdb, auth } from '@/plugins/firebase'
export default {
  mixins: [ helpers, binder ],
  props: {
    calculatorId: String,
    fields: Object
  },
  data () {
    return {
      editDialog: false,
      editTestCaseData: {},
      editCase: {},
      loading: true,
      testCases: {},
      testResults: [],
    }
  },
  computed: {
    ...mapGetters(['_user']),
    cases () {
      return this.showingTests ? this.testResults : this.testCases
    },
    showingTests () {
      return this.testResults.length > 0
    }
  },
  watch: {
    '$route.params.sub' () {
      this.bindTests()
    },
    '$route.params.id' () {
      this.bindTests()
    }
  },
  beforeMount () {
    this.bindTests()
  },
  methods: {
    bindTests () {
      // this.loading = false
      this.testResults = []
      this.testCases = {}

      // this.$unbindAll()

      if (this.$route.params.id === 'test') {
        this.$bindRtdb('testCases', `calculators/${this.calculatorId}/tests`, { loader: 'loading' })
        // this.$bindxxx(rtdb.ref(`calculators/${this.calculatorId}/tests`), 'testCases', 'loading')
      }
    },
    async runTest () {
      this.loading = true
      this.testResults = []
      if (this.$refs.data && this.$refs.data[0]) this.$refs.data[0].updateAll(false)
      if (this.$refs.calculation && this.$refs.calculation[0]) this.$refs.calculation[0].updateAll(false)

      const token = await auth.currentUser.getIdToken()

      let { data } = await axios({
        url: `${process.env.VUE_APP_API_URL}/calculators/${this.calculatorId}/tests/run`,
        method: 'POST',
        headers: { Authorization: 'Bearer ' + token }
      })
      this.testResults = data
      this.loading = false
    },
    titleClass ({result}) {
      if (result === undefined) return ''
      return result ? 'success--text' :  'error--text'
    },
    async loadCalculation (testId) {
      const token = await auth.currentUser.getIdToken()
      let variant = this.testCases[testId].data._variant
      
      window.open(`${process.env.VUE_APP_BASE_URL}/calculator/${this.calculatorId}/${variant}?testId=${testId}&token=${token}`)
    },
    editTestCase (testCase = {}) {
      this.editTestCaseData = testCase
      this.editDialog = true
    },
    deleteTestCase ({id}) {
      rtdb.ref(`calculators/${this.calculatorId}/tests/${id}`).set(null)
    }
  }
}
</script>

<style lang="css">

</style>
